<template>
  <div v-cloak class="Resource">
    <!-- 头部banner图 -->
    <div class="swiper">
      <div class="toptexts">
        <div class="imgtitle">国际影展</div>
        <div class="texts">新鲜资讯、随时播报、一网打尽</div>
      </div>
    </div>

    <div class="main">
      <div class="left pa-10 pa-tb-20">
        <Bread :list="breadList" />
        <div class="fon-26 weight500  ma-t-20">
          {{ detail.Name }}
        </div>
        <div class="flex f-between f-center">
          <div class="c-8a fon-12 flex f-center ma-t-15">
            <img src="../img/icontime.png" class="ma-r-10 img_12" />
            {{ detail.ReleaseTime }}
            <img src="../img/iconeye.png" class="ma-l-40 ma-r-10 img_14" />
            {{ detail.ViewCount }}人浏览
          </div>
          <div @click="toCollection(detail.Id)">
            <img
              src="../img/shoucang.png"
              class="img_25"
              v-if="!detail.IsCollection"
            />
            <img src="../img/shoucang1.png" class="img_25" v-else />
          </div>
        </div>
        <div class="ma-t-20 lh-html" v-html="detail.Content"></div>
      </div>
      <div class="right pa-tb-20 pa-lr-10">
        <div class="flex">
          <div class="blue_tab ma-r-10 fon-16"></div>
          可能感兴趣
        </div>

        <div
          class="right_box"
          v-for="(item, index) in detail.SimilarList"
          :key="index"
          @click.stop="toDetail(item.Id)"
        >
          <!-- <img :src="item.Image" /> -->
          <div class="ma-t-20 fon-18 font-bold t-omit-1">
            {{ item.Name }}
          </div>
          <div class="c-8a fon-12 flex f-center ma-t-20">
            <img src="../img/icontime.png" class="ma-r-10 img_12" />
            {{ item.ReleaseTime }}
            <img src="../img/iconeye.png" class="ma-l-40 ma-r-10 img_14" />
            {{ item.ViewCount }}人浏览
          </div>
        </div>
      </div>
    </div>
    <!-- 中间内容 -->
  </div>
</template>
<style >
.lh-html img{
  max-width: 100%;
}
</style>
<style lang="scss"  scoped>

body {
  //   min-width: 1200px;
  background: rgba(245, 247, 250, 1);
}
.Resource .swiper {
  width: 100%;
  height: 314px;
  background-image: url(../img/资讯.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  .toptexts {
    width: 736px;
    position: absolute;
    top: 28%;
    margin: 0 auto;
    left: 50%;
    margin-left: -368px;
    font-size: 20px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;

    color: #fff;
    opacity: 0.75;
    text-align: center;
    .texts {
      line-height: 30px;
      letter-spacing: 3px;
      font-size: 16px;
    }
    .imgtitle {
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 20px;
    }
  }
}

.main {
  width: 1200px;

  margin: 40px auto;
  display: flex;
  justify-content: space-between;

  .left {
    width: 777px;
    background: #fff;
    min-height: 1109px;
  }

  .right {
    width: 371px;
    background: #fff;
    min-height: 891px !important;

    .right_box {
      width: 350px;
      // height: 287px;
      margin: 0 auto;
      margin-top: 30px;
      padding: 0 12px 20px;
      border-bottom: 1px #eee solid !important;

      & img {
        width: 335px;
        height: 199px;
      }
    }
  }
}

.ma-t-60 {
  margin-top: 60px !important;
}
.ma-t-10 {
  margin-top: 10px !important;
}

.blue_tab {
  width: 4px;
  height: 20px;
  background: #fb004d;
  border-radius: 2px;
}
.img_12 {
  width: 12px !important;
  height: 12px !important;
}
.img_14 {
  width: 14px !important;
  height: 8px !important;
}
.img_32 {
  width: 32px;
  height: 32px;
}
.img_25 {
  width: 25px;
  height: 25px;
}
</style>
<script>
import { newsDetail, Collection } from "../api.js";
import Bread from "../components/Bread.vue";

// studycollect
export default {
  name: "Study-detail",
  components: {
    Bread,
  },
  props: {},
  data() {
    return {
      id: 0,
      detail: {},
      breadList: [
        { name: "国际影展", path: "/Resource" },
        { name: "正文", path: "/Study-detail" },
      ],
    };
  },

  created() {
    this.id = this.$route.query.id;
    this.getDetail();
  },
  beforeRouteEnter(to, from, next) {
    window.scroll(0, 0);
    // 判断是否从详情页面回来

    next();
  },

  // 其他页面进来时更新初始数据
  activated() {},

  methods: {
    login() {
      let token = localStorage.getItem("AccessToken") || "";
      if (!token) {
        this.$confirm("您还未登录请先登录?", "提示", {
          confirmButtonText: "去登录",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$router.push("/Login");
          })
          .catch(() => {
            return false;
          });
      } else {
        return true;
      }
    },
    toCollection(e) {
      if (this.login()) {
        let token = localStorage.getItem("AccessToken") || "";
        let data = {
          Id: e,
          Token: token,
        };
        Collection(data).then((res) => {
          // console.log(res);
          if (res.data.Code == 0) {
            this.detail.IsCollection = !this.detail.IsCollection;
            if (this.detail.IsCollection) {
              this.$message.success("收藏成功");
            } else {
              this.$message.success("已取消收藏");
            }
          }
        });
      }
    },
    getDetail() {
      let token = localStorage.getItem("AccessToken") || "";
      let data = {
        id: this.id,
        token: token,
      };
      newsDetail(data).then((res) => {
        if (res.data.Code == 0) {
          this.detail = res.data.Data;
        }
      });
    },

    toDetail(e) {
      // console.log(e);
      this.$router.push({
        path: "/Study-detail",
        query: {
          id: e,
         
        },
      });
    },

    upload(e) {
      window.open(e, "_blank");
    },
  },
};
</script>
